import caseSampleImage from '../assets/case_sample_img.png'

export const VIMEO_DEFAULT_THUMB_PATH_PREFIX = '/video/default'

export const VIDEO_THUMBNAIL_STATUS = {
  none: 'none',
  pending: 'pending',
  ready: 'ready',
  fallback: 'fallback',
}

export const getVideoUrls = (video = {}) => {
  return Array.isArray(video?.vimeoUrls) ? video.vimeoUrls.filter(Boolean) : []
}

export const hasVideoUrl = (video = {}) => {
  return getVideoUrls(video).length > 0
}

export const getLatestVideoUrl = (video = {}) => {
  const urls = getVideoUrls(video)
  return urls.length > 0 ? urls[urls.length - 1] : null
}

export const isLegacyDefaultThumbnail = (url) => {
  if (typeof url !== 'string') return false

  try {
    const parsed = new URL(url)
    return parsed.hostname === 'i.vimeocdn.com' && parsed.pathname.startsWith(VIMEO_DEFAULT_THUMB_PATH_PREFIX)
  } catch (_error) {
    return url.indexOf('i.vimeocdn.com/video/default') !== -1
  }
}

export const getRealThumbnailUrl = (video = {}) => {
  const thumbnailUrls = Array.isArray(video?.thumbnailUrls) ? video.thumbnailUrls.filter(Boolean) : []
  const actualUrls = thumbnailUrls.filter((url) => !isLegacyDefaultThumbnail(url))
  return actualUrls.length > 0 ? actualUrls[actualUrls.length - 1] : null
}

export const getThumbnailStatus = (video = {}) => {
  if (!hasVideoUrl(video)) return VIDEO_THUMBNAIL_STATUS.none
  if (getRealThumbnailUrl(video)) return VIDEO_THUMBNAIL_STATUS.ready
  if (video?.thumbnailStatus === VIDEO_THUMBNAIL_STATUS.ready) return VIDEO_THUMBNAIL_STATUS.fallback
  return video?.thumbnailStatus || VIDEO_THUMBNAIL_STATUS.pending
}

export const getDisplayThumbnailUrl = (video = {}) => {
  return getRealThumbnailUrl(video) || caseSampleImage
}